import { Component, type SyntheticEvent } from "react";
import { Section } from "../atoms/section";
import {
    type IPanelProps,
    Stack,
    type IRenderFunction,
    Panel,
    PanelType,
    SelectionMode,
} from "@fluentui/react";
import { type UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { action } from "mobx";
import css from "./panel-vehicle-group-details.scss";
import { ListCommandButtonsUserGroups } from "../organisms/list-command-buttons-user-groups";
import { ListUsers, ListUsersLayout as ListUsersColumnLayout } from "./list-users";
import { ListVehicleGroups } from "./list-vehicle-groups";
import { mapSome } from "../../utils/functions";

export interface PanelUserGroupDetailsProps {
    readonly isOpen: boolean;
    readonly userGroupId?: UUID;
    readonly onDismiss: (ev?: SyntheticEvent<HTMLElement> | KeyboardEvent) => void;
}

import { store } from "../../store";

@observer
export class PanelUserGroupDetails extends Component<PanelUserGroupDetailsProps> {
    @action.bound private renderHeader(): IRenderFunction<IPanelProps> {
        return (props, defaultRender) => (
            <>
                {defaultRender!(props)}
                <Stack horizontal verticalAlign="center">
                    <div className={css.commandButtons}>
                        <ListCommandButtonsUserGroups
                            canDelete
                            singleItemMode
                            itemId={this.props.userGroupId}
                            onDelete={(_evt) => this.props.onDismiss()}
                        />
                    </div>
                </Stack>
            </>
        );
    }

    public render(): JSX.Element {
        if (!this.props.userGroupId) {
            return <></>;
        }

        const userGroup = store.repositoryUserGroups.byId(this.props.userGroupId);
        const userCount = mapSome((count) => `${count}`, userGroup?.assignedUserCount) ?? "";
        const vehicleGroupCount =
            mapSome((count) => `${count}`, userGroup?.assignedVehicleGroupCount) ?? "";

        return (
            <Panel
                isOpen={this.props.isOpen}
                isBlocking={false}
                onDismiss={this.props.onDismiss}
                onRenderHeader={this.renderHeader()}
                type={PanelType.large}
                headerText={userGroup?.label}
            >
                <div className="flex flex-wrap gap-4">
                    <Section
                        withPadding
                        title={`${store.i18n.t(
                            "component.panelUserGroupDetails.users.title",
                        )} (${userCount})`}
                        className="min-w-xl flex-1"
                    >
                        <ListUsers
                            selectionMode={SelectionMode.none}
                            userGroupIds={[this.props.userGroupId]}
                            columnLayout={ListUsersColumnLayout.Group}
                            ignoreUrl
                            hideFilter
                        />
                    </Section>
                    <Section
                        withPadding
                        title={`${store.i18n.t(
                            "component.panelUserGroupDetails.vehicleGroups.title",
                        )} (${vehicleGroupCount})`}
                        className="min-w-xl flex-1"
                    >
                        <ListVehicleGroups
                            selectionMode={SelectionMode.none}
                            userGroupIds={[this.props.userGroupId]}
                            ignoreUrl
                            hideFilter
                        />
                    </Section>
                </div>
            </Panel>
        );
    }
}
